import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-578bf8a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "home-content" }

import {
  SwapOutlined,
  MenuOutlined,
  RedoOutlined,
} from "@ant-design/icons-vue";
import XDialog from "@/components/XDialog.vue";
import AllApp from "@/views/AllApp.vue";
import {
  defineAsyncComponent,
  onBeforeMount,
  onBeforeUnmount,
  onMounted,
  reactive,
  ref,
} from "vue";
import dayjs, { Dayjs } from "dayjs";
import Statistics from "@/views/statistics.vue";
import Subscription from "@/views/Subscription.vue";
import Back from "@/views/Back.vue";
import ads from "@/views/ads.vue";
import h5Ads from "@/views/H5Ads.vue";
import {
  sysConfigList,
  sysDailyList,
  loginOut,
  resetPassword,
} from "@/api/api";
import { removeToken } from "@/utils/auth";
import { useRouter } from "vue-router";
import { ts_to_time } from "@/utils/utils";
import LineChart from "./LineChart.vue";
type RangeValue = [Dayjs, Dayjs];
interface FormState {
  account: string;
  password: string;
  oldPassword: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DataCenter',
  setup(__props) {

const monthDay = () => {
  return 3600 * 24 * 1000 * 30;
};
const XATable = defineAsyncComponent(() => import("../components/XATable.vue"));
const activeName = ref("first");
const tableData = ref([] as any[]);
const activeKey = ref(-1);
const configList = ref([] as any[]);
const pageNo = ref(1);
const pageSize = ref(50);
const loading = ref(false);
const total = ref(0);
const dbName = ref("");
const dateValue = ref([dayjs().startOf("month"), dayjs()]);
const appIdVal = ref();

const monthString1 = String(
  new Date(ts_to_time(Number(new Date()))).getMonth() + 1
) as any;
const monthString2 = String(
  new Date(ts_to_time(Number(new Date()) - monthDay())).getMonth() + 1
) as any;
const monthString3 = String(
  new Date(ts_to_time(Number(new Date()) - monthDay() * 2)).getMonth() + 1
) as any;

const isXiaohao = ref(true);
const dialogVisible = ref();
const router = useRouter();
const modeChangeKey = ref();
const isCardMode = ref(localStorage.getItem("mode") === "admin");
const screenHeight = window.innerHeight - 320;
const regUserCom = (scope: any) => {
  if (scope.record) {
    return (
      scope.record.fbNewUse /
      100 /
      Number(scope.record.reg ? scope.record.reg : 0)
    ).toFixed(2);
  } else {
    return 0;
  }
};
const formState = ref<FormState>({
  account: localStorage.getItem("mode") === "admin" ? "admin" : "user",
  password: "",
  oldPassword: "",
});
const isRefresh = ref(false);
var rangePresets = reactive({} as any);

const reload = () => {
  isRefresh.value = !isRefresh.value
  getConfigList();
};

const assignmentDate = (mode: string) => {
  console.log(mode);
  if (mode === "card") {
    dateValue.value = [dayjs(), dayjs()];
    getConfigList();
  } else if (mode === "table") {
    dateValue.value = [dayjs().startOf("month"), dayjs()];
    // dayjs().subtract(30, "day").startOf("day")
    getConfigList();
  } else if (mode === "linechart") {
    dateValue.value = [dayjs().startOf("month"), dayjs()];
  }
};

const modeChangeClick = (mode: string) => {
  assignmentDate(mode);
  localStorage.setItem("MODE", mode);
};
const editPassword = () => {
  dialogVisible.value = true;
};
const loginOutClick = () => {
  loginOut({}).then((res) => {
    router.replace("/");
    removeToken();
  });
};
const confirm = () => {
  resetPassword(formState.value).then((res) => {
    if (res.code === "200") {
      loginOutClick();
    }
  });
};
const onFinishFailed = () => {};
onBeforeMount(() => {
  if (localStorage.getItem("MODE")) {
    modeChangeKey.value = localStorage.getItem("MODE") as string;
    // 判断是否是user
    if (!isCardMode.value) {
      if (localStorage.getItem("MODE") === "table") {
        modeChangeKey.value = "card";
      }
    }
  } else {
    modeChangeKey.value = "card";
  }
});
onMounted(() => {
  let xiaohao = localStorage.getItem("XIAOHAO");
  if (xiaohao === "1") {
    isXiaohao.value = true;
  } else {
    isXiaohao.value = false;
  }
  isXiaohao.value
    ? (columns.value = columns1.value)
    : (columns.value = columns2.value);
  assignmentDate(modeChangeKey.value);
  rangePresets[monthString1 + "月"] = [
    dayjs()
      .month(monthString1 - 1)
      .startOf("month"),
    dayjs()
      .month(monthString1 - 1)
      .endOf("month"),
  ] as RangeValue;

  rangePresets[monthString2 + "月"] = [
    dayjs()
      .month(monthString1 - 2)
      .startOf("month"),
    dayjs()
      .month(monthString1 - 2)
      .endOf("month"),
  ] as RangeValue;

  rangePresets[monthString3 + "月"] = [
    dayjs()
      .month(monthString1 - 3)
      .startOf("month"),
    dayjs()
      .month(monthString1 - 3)
      .endOf("month"),
  ] as RangeValue;

  getConfigList();
});

const getConfigList = () => {
  loading.value = true;
  sysConfigList({
    isUse: isXiaohao.value ? 0 : 1,
  }).then((res: any) => {
    // console.log(res);
    configList.value = res.data;
    getDatas(dbName.value);
  });
};
const getDatas = (dbName: String = "") => {
  const params = {
    dbName: dbName,
    pageNo: pageNo.value,
    pageSize: pageSize.value,
    beginTime: dayjs(dateValue.value[0]).format("YYYY-MM-DD"),
    endTime: dayjs(dateValue.value[1]).format("YYYY-MM-DD"),
    isUse: isXiaohao.value ? 0 : 1,
  };
  loading.value = true;
  sysDailyList(params).then((res) => {
    loading.value = false;
    total.value = res.data.total;
    if (res.code === "200") {
      var data: any[] = [];
      res.data.records.forEach((element: { day: string }) => {
        if (element && !element.day) {
          element.day = "汇总";
        }
        data.push(element);
      });
      tableData.value = data;
    }
  });
};
const xiaohaoClick = () => {
  isXiaohao.value = !isXiaohao.value;
  isXiaohao.value
    ? (columns.value = columns1.value)
    : (columns.value = columns2.value);
  localStorage.setItem("XIAOHAO", isXiaohao.value ? "1" : "0");
  getConfigList();
};
const tabClick = (tabIndex: any) => {
  if (tabIndex === -1) {
    dbName.value = "";
  } else {
    const item = configList.value[tabIndex];
    dbName.value = item.dbName;
  }
  getDatas(dbName.value);
};
const pageNoChange = (val: number) => {
  pageNo.value = val;
  getDatas(dbName.value);
};
const onShowSizeChange = (current: any, size: number) => {
  pageSize.value = size;
  getDatas(dbName.value);
};
const onRangeChange = (dates: RangeValue, dateStrings: string[]) => {
  getDatas(dbName.value);
};
const columns1 = ref([
  // {
  //   title: "序号",
  //   dataIndex: "index",
  //   key: "index",
  //   align: "center",
  //   customRender: (column: { index: number }) => {
  //     return (pageNo.value - 1) * pageSize.value + column.index + 1;
  //     // return column.index + 1;
  //   },
  //   width: 60,
  // },
  {
    title: "日期",
    key: "day",
    dataIndex: "day",
    width: 120,
  },
  {
    title: "新增用户数",
    key: "count",
    dataIndex: "count",
    slots: {
      customRender: "count",
    },
  },
  {
    title: "新增注册人数",
    key: "reg",
    dataIndex: "reg",
  },
  {
    title: "充值用户数",
    key: "totalRecharge",
    dataIndex: "totalRecharge",
  },
  {
    title: "充值成功用户数",
    key: "successRecharge",
    dataIndex: "successRecharge",
  },
  {
    title: "充值总金额",
    key: "rechargeTotalAmount",
    dataIndex: "rechargeTotalAmount",
    isMinute: true,
    symbol: "$",
  },
  {
    title: "开通VIP数",
    key: "totalVipNum",
    dataIndex: "totalVipNum",
  },
  {
    title: "开通VIP成功数",
    key: "successVipNum",
    dataIndex: "successVipNum",
  },
  {
    title: "开通VIP总金额",
    key: "vipTotalAmount",
    dataIndex: "vipTotalAmount",
    symbol: "$",
    isMinute: true,
  },
  {
    title: "开通SVIP数",
    key: "totalSvipNum",
    dataIndex: "totalSvipNum",
  },
  {
    title: "开通SVIP成功数",
    key: "successSvipNum",
    dataIndex: "successSvipNum",
  },
  {
    title: "开通SVIP总金额",
    key: "svipTotalAmount",
    dataIndex: "svipTotalAmount",
    symbol: "$",
    isMinute: true,
  },
  {
    title: "新增付费用户数",
    key: "newPayUserNum",
    dataIndex: "newPayUserNum",
  },
  {
    title: "新增付费用户金额",
    key: "newPayUserSumAmount",
    dataIndex: "newPayUserSumAmount",
    symbol: "$",
    isMinute: true,
  },
  {
    title: "退款金额",
    key: "refundAmount",
    dataIndex: "refundAmount",
    symbol: "$",
    isMinute: true,
  },
  {
    title: "总收入",
    key: "totalRevenue",
    dataIndex: "totalRevenue",
    symbol: "$",
    isMinute: true,
  },
]);

const columns2 = ref([
  // {
  //   title: "序号",
  //   dataIndex: "index",
  //   key: "index",
  //   align: "center",
  //   customRender: (column: { index: number }) => {
  //     return (pageNo.value - 1) * pageSize.value + column.index + 1;
  //     // return column.index + 1;
  //   },
  //   width: 60,
  // },
  {
    title: "日期",
    key: "day",
    dataIndex: "day",
    width: 120,
  },
  {
    title: "总消耗",
    key: "cnUse",
    dataIndex: "cnUse",
    symbol: "$",
    isMinute: true,
    width: 120,
  },
  {
    title: "新增消耗",
    key: "fbNewUse",
    dataIndex: "fbNewUse",
    symbol: "$",
    isMinute: true,
    width: 120,
  },
  {
    title: "销量消耗",
    key: "fbUse",
    dataIndex: "fbUse",
    symbol: "$",
    isMinute: true,
    width: 120,
  },
  {
    title: "新增用户数",
    key: "count",
    dataIndex: "count",
    slots: {
      customRender: "count",
    },
    width: 100,
  },
  {
    title: "安装成本",
    key: "installUse",
    dataIndex: "installUse",
    slots: {
      customRender: "installUse",
    },
    width: 120,
  },
  {
    title: "新增注册人数",
    key: "reg",
    dataIndex: "reg",
    width: 100,
  },
  {
    title: "注册成本",
    key: "regUse",
    dataIndex: "regUse",
    slots: {
      customRender: "regUse",
    },
    width: 100,
  },
  {
    title: "总提交订单数",
    key: "totalOrderCount",
    dataIndex: "totalOrderCount",
    width: 100,
  },
  {
    title: "总订单支付数",
    key: "totalOrderSuccess",
    dataIndex: "totalOrderSuccess",
    width: 100,
  },
  {
    title: "充值用户数",
    key: "totalRecharge",
    dataIndex: "totalRecharge",
    width: 100,
  },
  {
    title: "充值成功用户数",
    key: "successRecharge",
    dataIndex: "successRecharge",
    width: 100,
  },
  {
    title: "充值总金额",
    key: "rechargeTotalAmount",
    dataIndex: "rechargeTotalAmount",
    isMinute: true,
    symbol: "$",
    width: 120,
  },
  {
    title: "充值平均付费",
    key: "rechargeAverageAmount",
    dataIndex: "rechargeAverageAmount",
    slots: {
      customRender: "rechargeAverageAmount",
    },
    width: 120,
  },
  {
    title: "开通VIP数",
    key: "totalVipNum",
    dataIndex: "totalVipNum",
    width: 100,
  },
  {
    title: "开通VIP成功数",
    key: "successVipNum",
    dataIndex: "successVipNum",
    width: 100,
  },
  {
    title: "开通VIP总金额",
    key: "vipTotalAmount",
    dataIndex: "vipTotalAmount",
    symbol: "$",
    isMinute: true,
    width: 120,
  },
  {
    title: "VIP平均付费",
    key: "vipAverageAmount",
    dataIndex: "vipAverageAmount",
    slots: {
      customRender: "vipAverageAmount",
    },
    width: 100,
  },
  {
    title: "开通SVIP数",
    key: "totalSvipNum",
    dataIndex: "totalSvipNum",
    width: 100,
  },
  {
    title: "开通SVIP成功数",
    key: "successSvipNum",
    dataIndex: "successSvipNum",
    width: 100,
  },
  {
    title: "开通SVIP总金额",
    key: "svipTotalAmount",
    dataIndex: "svipTotalAmount",
    symbol: "$",
    isMinute: true,
    width: 120,
  },
  {
    title: "SVIP平均付费",
    key: "svipAverageAmount",
    dataIndex: "svipAverageAmount",
    slots: {
      customRender: "svipAverageAmount",
    },
    width: 100,
  },
  {
    title: "新增付费用户数",
    key: "newPayUserNum",
    dataIndex: "newPayUserNum",
    width: 100,
  },
  {
    title: "新增付费用户金额",
    key: "newPayUserSumAmount",
    dataIndex: "newPayUserSumAmount",
    symbol: "$",
    isMinute: true,
    width: 120,
  },
  {
    title: "新增用户平均金额",
    key: "newPayUserAverageAmount",
    dataIndex: "newPayUserAverageAmount",
    slots: {
      customRender: "newPayUserAverageAmount",
    },
    width: 100,
  },
  {
    title: "TikTok消耗",
    key: "ttUse",
    dataIndex: "ttUse",
    symbol: "$",
    isMinute: true,
    width: 120,
  },
  {
    title: "海外户消耗",
    key: "otherUse",
    dataIndex: "otherUse",
    symbol: "₦",
    isMinute: true,
    width: 120,
  },
  {
    title: "退款金额",
    key: "refundAmount",
    dataIndex: "refundAmount",
    symbol: "$",
    isMinute: true,
    width: 120,
  },
  {
    title: "盈利",
    key: "dayProfit",
    dataIndex: "dayProfit",
    symbol: "$",
    isMinute: true,
    width: 120,
  },
  {
    title: "总收入",
    key: "totalRevenue",
    dataIndex: "totalRevenue",
    symbol: "$",
    isMinute: true,
    width: 120,
  },
]);

const columns = ref<any>(columns1.value);

return (_ctx: any,_cache: any) => {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(modeChangeKey.value === 'card' ? 'nav' : 'nav2')
    }, [
      _createElementVNode("div", null, [
        (
          modeChangeKey.value === 'card' ||
          modeChangeKey.value === 'table' ||
          modeChangeKey.value === 'ads' ||
          modeChangeKey.value === 'linechart' ||
          modeChangeKey.value === 'h5Ads'
        )
          ? (_openBlock(), _createBlock(_component_a_range_picker, {
              key: 0,
              style: {"margin-right":"10px"},
              format: "YYYY-MM-DD",
              value: dateValue.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dateValue).value = $event)),
              ranges: _unref(rangePresets),
              onChange: onRangeChange
            }, null, 8, ["value", "ranges"]))
          : _createCommentVNode("", true),
        (modeChangeKey.value === 'table' && isCardMode.value)
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 1,
              class: "all",
              type: "primary",
              onClick: xiaohaoClick,
              disabled: loading.value
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(SwapOutlined))
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(isXiaohao.value ? "全部" : "消耗") + " ", 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (modeChangeKey.value != 'linechart')
          ? (_openBlock(), _createBlock(_component_a_button, {
              key: 2,
              type: "primary",
              class: "refresh",
              onClick: reload,
              disabled: loading.value
            }, {
              icon: _withCtx(() => [
                _createVNode(_unref(RedoOutlined))
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_dropdown, {
          trigger: ['click'],
          class: "all"
        }, {
          overlay: _withCtx(() => [
            _createVNode(_component_a_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_menu_item, {
                  key: "1",
                  onClick: editPassword
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 修改密码 ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, {
                  key: "2",
                  onClick: loginOutClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 退出登录 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_button, null, {
              icon: _withCtx(() => [
                _createVNode(_unref(MenuOutlined))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_a_tabs, {
          activeKey: modeChangeKey.value,
          "onUpdate:activeKey": _cache[4] || (_cache[4] = ($event: any) => ((modeChangeKey).value = $event)),
          type: "card",
          onChange: modeChangeClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, {
              key: "card",
              tab: "汇总显示"
            }, {
              default: _withCtx(() => [
                _createVNode(AllApp, {
                  appData: configList.value,
                  dateTime: dateValue.value,
                  "is-consume": isXiaohao.value,
                  loading: loading.value,
                  isRefresh: isRefresh.value
                }, null, 8, ["appData", "dateTime", "is-consume", "loading", "isRefresh"])
              ]),
              _: 1
            }),
            (isCardMode.value)
              ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: "table",
                  tab: "列表显示"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tabs, {
                      activeKey: activeKey.value,
                      "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((activeKey).value = $event)),
                      onTabClick: tabClick
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_a_tab_pane, {
                          key: -1,
                          tab: "全部"
                        })),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(configList.value, (item, index) => {
                          return (_openBlock(), _createBlock(_component_a_tab_pane, {
                            key: index,
                            tab: item.packageName,
                            disabled: loading.value
                          }, null, 8, ["tab", "disabled"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["activeKey"]),
                    _createVNode(_unref(XATable), {
                      columns: columns.value,
                      dataSource: tableData.value,
                      scroll: { x: 1500, y: screenHeight },
                      loading: loading.value
                    }, {
                      count: _withCtx(({ scope }) => [
                        _createTextVNode(_toDisplayString(scope.record
                  ? Number(
                      scope.record.newAndroidUser
                        ? scope.record.newAndroidUser
                        : 0
                    ) +
                    Number(
                      scope.record.newIosUser ? scope.record.newIosUser : 0
                    ) +
                    Number(scope.record.reg ? scope.record.reg : 0)
                  : 0), 1)
                      ]),
                      regUse: _withCtx(({ scope }) => [
                        _createTextVNode(" $" + _toDisplayString(regUserCom(scope)), 1)
                      ]),
                      installUse: _withCtx(({ scope }) => [
                        _createTextVNode(" $" + _toDisplayString(scope.record
                  ? (
                      scope.record.fbNewUse /
                      100 /
                      (Number(
                        scope.record.newAndroidUser
                          ? scope.record.newAndroidUser
                          : 0
                      ) +
                        Number(
                          scope.record.newIosUser ? scope.record.newIosUser : 0
                        ) +
                        Number(scope.record.reg ? scope.record.reg : 0))
                    ).toFixed(2)
                  : 0), 1)
                      ]),
                      rechargeAverageAmount: _withCtx(({ scope }) => [
                        _createTextVNode(" $" + _toDisplayString(scope.record
                  ? (
                      scope.record.rechargeTotalAmount /
                      100 /
                      scope.record.successRecharge
                    ).toFixed(2)
                  : 0), 1)
                      ]),
                      vipAverageAmount: _withCtx(({ scope }) => [
                        _createTextVNode(" $" + _toDisplayString(scope.record
                  ? (
                      scope.record.vipTotalAmount /
                      100 /
                      scope.record.successVipNum
                    ).toFixed(2)
                  : 0), 1)
                      ]),
                      svipAverageAmount: _withCtx(({ scope }) => [
                        _createTextVNode(" $" + _toDisplayString(scope.record
                  ? (
                      scope.record.svipTotalAmount /
                      100 /
                      scope.record.successSvipNum
                    ).toFixed(2)
                  : 0), 1)
                      ]),
                      newPayUserAverageAmount: _withCtx(({ scope }) => [
                        _createTextVNode(" $" + _toDisplayString(scope.record
                  ? (
                      scope.record.newPayUserSumAmount /
                      100 /
                      scope.record.newPayUserNum
                    ).toFixed(2)
                  : 0), 1)
                      ]),
                      _: 1
                    }, 8, ["columns", "dataSource", "scroll", "loading"]),
                    _createVNode(_component_a_pagination, {
                      current: pageNo.value,
                      "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((pageNo).value = $event)),
                      pageSize: pageSize.value,
                      "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageSize).value = $event)),
                      onChange: pageNoChange,
                      total: total.value,
                      "show-size-changer": "",
                      onShowSizeChange: onShowSizeChange,
                      style: {"margin-top":"5px"}
                    }, null, 8, ["current", "pageSize", "total"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_tab_pane, {
              key: "linechart",
              tab: "折线图"
            }, {
              default: _withCtx(() => [
                _createVNode(LineChart, {
                  "data-source": tableData.value,
                  columns: columns2.value,
                  appData: configList.value,
                  dateTime: dateValue.value
                }, null, 8, ["data-source", "columns", "appData", "dateTime"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, {
              key: "statistics",
              tab: "监控统计",
              class: "a-tab-pane-content"
            }, {
              default: _withCtx(() => [
                _createVNode(Statistics, {
                  dbName: appIdVal.value,
                  "is-refresh": isRefresh.value,
                  appData: configList.value
                }, null, 8, ["dbName", "is-refresh", "appData"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, {
              key: "subscription",
              tab: "订阅监测",
              class: "a-tab-pane-content"
            }, {
              default: _withCtx(() => [
                _createVNode(Subscription, {
                  dbName: appIdVal.value,
                  "is-refresh": isRefresh.value,
                  appData: configList.value
                }, null, 8, ["dbName", "is-refresh", "appData"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, {
              key: "back",
              tab: "退款监听",
              class: "a-tab-pane-content"
            }, {
              default: _withCtx(() => [
                _createVNode(Back, {
                  dbName: appIdVal.value,
                  "is-refresh": isRefresh.value,
                  appData: configList.value
                }, null, 8, ["dbName", "is-refresh", "appData"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, {
              key: "ads",
              tab: "Adm广告",
              class: "a-tab-pane-content"
            }, {
              default: _withCtx(() => [
                _createVNode(ads, {
                  "is-refresh": isRefresh.value,
                  dateTime: dateValue.value
                }, null, 8, ["is-refresh", "dateTime"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, {
              key: "h5Ads",
              tab: "H5广告",
              class: "a-tab-pane-content"
            }, {
              default: _withCtx(() => [
                _createVNode(h5Ads, {
                  "is-refresh": isRefresh.value,
                  dateTime: dateValue.value
                }, null, 8, ["is-refresh", "dateTime"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["activeKey"])
      ])
    ]),
    _createVNode(XDialog, {
      title: "修改密码",
      visible: dialogVisible.value,
      onConfirm: confirm,
      onCancel: _cache[8] || (_cache[8] = ($event: any) => (dialogVisible.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: formState.value,
          name: "basic",
          "label-col": { span: 6 },
          "wrapper-col": { span: 18 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "用户名",
              name: "account",
              rules: [{ required: false, message: '请输入用户名!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  disabled: "",
                  value: formState.value.account,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((formState.value.account) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "旧密码",
              name: "oldPassword",
              rules: [{ required: true, message: '请输入旧密码!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: formState.value.oldPassword,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((formState.value.oldPassword) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "新密码",
              name: "password",
              rules: [{ required: true, message: '请输入新密码!' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  value: formState.value.password,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((formState.value.password) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})